import { DESIGN_ITEM_CATEGORY3, FACILITY_TYPE } from "@constants/inbound";
import { useAtom } from "jotai";
import { hcostInboundAtom } from "@/store/hcost-atom";
import { NumberBox } from "devextreme-react";
import { CounselDesignItemTree } from "@feature/counsel/update/counsel-design-info";

type Props = {
  data: CounselDesignItemTree;
};

export const CounselDesignItemQuantity = ({ data }: Props) => {
  const [hCostResult, setHCostResult] = useAtom(hcostInboundAtom);
  const designItemQuantityHandler = (e: any, key: string, code: string) => {
    if (!e) return;
    setHCostResult(prev => {
      const data = prev.counselDesigns[0].counselDesignItems
        .filter((v: CounselDesignItem) => v.category3.code === code)
        .find((i: CounselDesignItem) => i.itemValue.code !== "000" && i.enabled);
      if (data) {
        // @ts-ignore
        data[key] = e.value;
        const num1 = data.num1 || 1;
        const num2 = data.num2 || 1;
        data.itemCount = num1 * num2;
      }
    });
  };

  const makeQuantityData = () => {
    const code = hCostResult.counselDesigns[0].facilityType?.code;
    if (
      data.category3.code === DESIGN_ITEM_CATEGORY3.GATE_BACK ||
      data.category3.code === DESIGN_ITEM_CATEGORY3.GATE_FRONT
    ) {
      return (
        <div className="flex ml-2">
          {(code === FACILITY_TYPE.INTERLOCK || code === FACILITY_TYPE.VENLO) && (
            <div className="flex mr-5">
              <div>설치 동수</div>
              <NumberBox
                className="ml-3 mb-1 w-24"
                format={"#,##0.#동"}
                max={100}
                min={1}
                defaultValue={1}
                showSpinButtons={true}
                step={1}
                value={
                  hCostResult.counselDesigns[0].counselDesignItems
                    .filter((v: CounselDesignItem) => v.category3?.code === data.category3.code)
                    .find((i: CounselDesignItem) => i.itemValue?.code !== "000" && i.enabled)?.num2
                }
                onValueChanged={e => designItemQuantityHandler(e, "num2", data.category3.code)}
              />
            </div>
          )}
          <div className="flex">
            <div>문짝 개수</div>
            <NumberBox
              className="ml-3 mb-1 w-24"
              format={"#,##0.#짝"}
              max={2}
              min={1}
              defaultValue={2}
              showSpinButtons={true}
              step={1}
              value={
                hCostResult.counselDesigns[0].counselDesignItems
                  .filter((v: CounselDesignItem) => v.category3?.code === data.category3.code)
                  .find((i: CounselDesignItem) => i.itemValue?.code !== "000" && i.enabled)?.num1
              }
              onValueChanged={e => designItemQuantityHandler(e, "num1", data.category3.code)}
            />
          </div>
        </div>
      );
    } else if (data.category3.code === DESIGN_ITEM_CATEGORY3.WINDOW) {
      return (
        <div className="flex ml-6">
          <div>창문 개수</div>
          <NumberBox
            className="ml-3 mb-1 w-24"
            format={"#,##0.#개"}
            max={100}
            min={1}
            defaultValue={2}
            showSpinButtons={true}
            step={1}
            value={
              hCostResult.counselDesigns[0].counselDesignItems
                .filter((v: CounselDesignItem) => v.category3?.code === data.category3.code)
                .find((i: CounselDesignItem) => i.itemValue?.code !== "000" && i.enabled)?.num1
            }
            onValueChanged={e => designItemQuantityHandler(e, "num1", data.category3.code)}
          />
        </div>
      );
    }
  };

  return <div className="ml-3 mb-1">{makeQuantityData()}</div>;
};
